import i18n from '@src/plugins/i18n'

export const GROUP_COLOR = {
  PEOPLEMEDICINE: '#EDA69D',
  PREVENTIVEMEDICINE: '#D6CFFF',
}
export const genderItem = [
  { text: i18n.t('gender.male'), value: 0 },
  { text: i18n.t('gender.female'), value: 1 },
]
export const defaultTypeButon = {
  detail: {
    icon: 'mdi-information-outline',
    title: i18n.t('actions.detail'),
    color: '',
  },
  download: {
    icon: 'mdi-download',
    title: i18n.t('actions.download'),
    color: '',
  },
  upload: {
    icon: 'mdi-upload',
    title: i18n.t('actions.upload'),
    color: '',
  },
  add: {
    icon: 'mdi-plus',
    title: i18n.t('actions.add'),
    color: 'primary',
  },
  create: {
    icon: 'mdi-plus',
    title: i18n.t('actions.create'),
    color: 'primary',
  },
  update: {
    icon: 'mdi-pencil',
    title: i18n.t('actions.update'),
    color: 'primary',
  },
  delete: {
    icon: 'mdi-delete-outline',
    title: i18n.t('actions.delete'),
    color: 'error',
  },
  reset: {
    icon: 'mdi-restart',
    title: i18n.t('actions.reset'),
    color: '',
  },
  reload: {
    icon: 'mdi-restart',
    title: i18n.t('actions.reset'),
    color: '',
  },
  setting: {
    icon: 'mdi-cog',
    title: i18n.t('actions.setting'),
    color: 'primary',
  },
}

export const lang_supports = [
  {
    icon: '/images/flag/vietnam-flag.png',
    key: 'vi',
  },
  {
    icon: '/images/flag/united-kingdom-flag.png',
    key: 'en',
  },
]

export const STATUS_TYPE = {
  CREATED: { text: 'Đã được tạo', value: 'created', color: '#898989' },
  PROCESSING: { text: 'Đang tiến hành', value: 'processing', color: '#00A3FF' },
  COMPLETED: { text: 'Hoàn thành', value: 'completed', color: 'success' },
  FAILED: { text: 'Thất bại', value: 'failed', color: 'error' },
  CANCEL: { text: 'Huỷ bỏ', value: 'cancelled', color: 'error' },
}
